import { cdn } from '@shared/utils/cdnAssets/cdn';

// The blank envelope art every envelope preview draws the design onto.
export const ENVELOPE_BACK = cdn('joy-web/cards/customizer/envelope-back.png');
export const ENVELOPE_FRONT = cdn('joy-web/cards/customizer/envelope-front.png');
